export var SET_PLANS_FOR_ASSET_REQUEST = 'SET_PLANS_FOR_ASSET_REQUEST';
export var SET_PLANS_FOR_ASSET_SUCCESS = 'SET_PLANS_FOR_ASSET_SUCCESS';
export var SET_PLANS_FOR_ASSET_FAIL = 'SET_PLANS_FOR_ASSET_FAIL';
export var GET_PLANS_FOR_ASSET_REQUEST = 'GET_PLANS_FOR_ASSET_REQUEST';
export var GET_PLANS_FOR_ASSET_SUCCESS = 'GET_PLANS_FOR_ASSET_SUCCESS';
export var GET_PLANS_FOR_ASSET_FAIL = 'GET_PLANS_FOR_ASSET_FAIL';
export var CLEAR_ERRORS = 'CLEAR_ERRORS';